exports.extraInfoConstants = {
 TITLE_MAX_LENGTH: 100,
 INFO_MAX_LENGTH: 1000
}